import AdConsole from './AdConsole.js';
import AddTotal from './AddTotal.js';
import Admin from './Admin.js';
import Alliance from './Alliance.js';
import Angle from './Angle.js';
import AngleThin from './AngleThin.js';
import Approve from './Approve.js';
import Archive from './Archive.js';
import Arrow from './Arrow.js';
import ArrowDnd from './ArrowDnd.js';
import ArticleLength from './ArticleLength.js';
import Bag from './Bag.js';
import Ban from './Ban.js';
import BarChart from './BarChart.js';
import Billing from './Billing.js';
import Booked from './Booked.js';
import BusinessClick from './BusinessClick.js';
import Camera from './Camera.js';
import Cancel from './Cancel.js';
import Caret from './Caret.js';
import Check from './Check.js';
import CheckCircle from './CheckCircle.js';
import Checkmark from './Checkmark.js';
import Clipboard from './Clipboard.js';
import Close from './Close.js';
import Cloud from './Cloud.js';
import Code from './Code.js';
import Cogs from './Cogs.js';
import Coins from './Coins.js';
import CoinsAlt from './CoinsAlt.js';
import CoinsStack from './CoinsStack.js';
import Collapse from './Collapse.js';
import Columns from './Columns.js';
import Compass from './Compass.js';
import Copy from './Copy.js';
import CopyAlt from './CopyAlt.js';
import Cross from './Cross.js';
import Customer from './Customer.js';
import Dashboard from './Dashboard.js';
import Database from './Database.js';
import Desktop from './Desktop.js';
import Diskette from './Diskette.js';
import DollarAlt from './DollarAlt.js';
import DollarSign from './DollarSign.js';
import Dot from './Dot.js';
import DoubleArrow from './DoubleArrow.js';
import Download from './Download.js';
import DragIndicator from './DragIndicator.js';
import Edit from './Edit.js';
import EditAlt from './EditAlt.js';
import Ellipsis from './Ellipsis.js';
import Email from './Email.js';
import EmailAlt from './EmailAlt.js';
import Envelope from './Envelope.js';
import Error from './Error.js';
import ExcludeRow from './ExcludeRow.js';
import Expand from './Expand.js';
import Export from './Export.js';
import Facebook from './Facebook.js';
import FileDownload from './FileDownload.js';
import Files from './Files.js';
import FileSearch from './FileSearch.js';
import FileType from './FileType/index.js';
import Filter from './Filter.js';
import FilterRemove from './FilterRemove.js';
import Format from './Format.js';
import GetMoney from './GetMoney.js';
import GroupRow from './GroupRow.js';
import Hide from './Hide.js';
import Image from './Image.js';
import Import from './Import.js';
import Incomplete from './Incomplete.js';
import Indicator from './Indicator.js';
import Info from './Info.js';
import Information from './Information.js';
import Instagram from './Instagram.js';
import Laptop from './Laptop.js';
import Like from './Like.js';
import List from './List.js';
import ListAlt from './ListAlt.js';
import Loading from './Loading.js';
import Location from './Location.js';
import Locked from './Locked.js';
import Megaphone from './Megaphone.js';
import Messenger from './Messenger.js';
import Minus from './Minus.js';
import MinusCircle from './MinusCircle.js';
import MinusSquare from './MinusSquare.js';
import Mobile from './Mobile.js';
import More from './More.js';
import Move from './Move.js';
import Notes from './Notes.js';
import Paperclip from './Paperclip.js';
import PersonAdd from './PersonAdd.js';
import PersonRemove from './PersonRemove.js';
import Phone from './Phone.js';
import PhoneBook from './PhoneBook.js';
import Placeholder from './Placeholder.js';
import Play from './Play.js';
import Plus from './Plus.js';
import PlusCircle from './PlusCircle.js';
import PlusSquare from './PlusSquare.js';
import Pointer from './Pointer.js';
import PointerAlt from './PointerAlt.js';
import PriceTag from './PriceTag.js';
import Printer from './Printer.js';
import Process from './Process.js';
import ProjectStatus from './ProjectStatus.js';
import QuestionCircle from './QuestionCircle.js';
import Reload from './Reload.js';
import ReportLevelFirst from './ReportLevelFirst.js';
import ReportLevelSecond from './ReportLevelSecond.js';
import ReportLevelThird from './ReportLevelThird.js';
import ReportLevelThirdReverse from './ReportLevelThirdReverse.js';
import Reset from './Reset.js';
import Restore from './Restore.js';
import RowsLimit from './RowsLimit.js';
import Rss from './Rss.js';
import Ruler from './Ruler.js';
import Screenshot from './Screenshot.js';
import Search from './Search.js';
import Settings from './Settings.js';
import Shrink from './Shrink.js';
import Sort from './Sort.js';
import SortAsc from './SortAsc.js';
import SortBold from './SortBold.js';
import SortDesc from './SortDesc.js';
import Speed from './Speed.js';
import Stop from './Stop.js';
import Success from './Success.js';
import Sync from './Sync.js';
import TableSort from './TableSort.js';
import Tablet from './Tablet.js';
import TargetMan from './TargetMan.js';
import Trash from './Trash.js';
import Twitter from './Twitter.js';
import Unlocked from './Unlocked.js';
import User from './User.js';
import Users from './Users.js';
import Verified from './Verified.js';
import Views from './Views.js';
import ViewsFocus from './ViewsFocus.js';
import Visible from './Visible.js';
import Warning from './Warning.js';
import WarningCircle from './WarningCircle.js';
import WarningCircleAlt from './WarningCircleAlt.js';
import Xandr from './Xandr.js';
import Xing from './Xing.js';
import Youtube from './Youtube.js';
const Icons = {
    FileType,
    Admin,
    Alliance,
    Angle,
    AngleThin,
    Archive,
    Export,
    ArticleLength,
    Approve,
    AdConsole,
    AddTotal,
    Arrow,
    ArrowDnd,
    BarChart,
    Bag,
    Billing,
    Booked,
    Check,
    CheckCircle,
    Camera,
    Cancel,
    Caret,
    Close,
    Cloud,
    Columns,
    Database,
    Desktop,
    DollarSign,
    DollarAlt,
    Dot,
    DoubleArrow,
    Download,
    Import,
    Email,
    EmailAlt,
    Edit,
    EditAlt,
    Error,
    Facebook,
    Instagram,
    Indicator,
    Twitter,
    Xing,
    Youtube,
    FileSearch,
    Files,
    FilterRemove,
    Filter,
    Image,
    Info,
    Hide,
    Like,
    List,
    ListAlt,
    Megaphone,
    Move,
    Phone,
    Plus,
    PlusCircle,
    PlusSquare,
    Printer,
    Process,
    QuestionCircle,
    Rss,
    Success,
    TargetMan,
    Trash,
    Users,
    Warning,
    WarningCircle,
    WarningCircleAlt,
    Reset,
    Restore,
    Compass,
    BusinessClick,
    Notes,
    Dashboard,
    User,
    Settings,
    Copy,
    CopyAlt,
    Views,
    ViewsFocus,
    Verified,
    Clipboard,
    Sync,
    Play,
    Ban,
    Cogs,
    Coins,
    CoinsAlt,
    CoinsStack,
    Envelope,
    Ruler,
    Reload,
    Checkmark,
    Cross,
    Locked,
    Location,
    Loading,
    Minus,
    MinusCircle,
    MinusSquare,
    Unlocked,
    Messenger,
    Mobile,
    Information,
    Tablet,
    Incomplete,
    Search,
    Diskette,
    RowsLimit,
    GroupRow,
    TableSort,
    Sort,
    SortBold,
    SortAsc,
    SortDesc,
    Ellipsis,
    DragIndicator,
    FileDownload,
    ExcludeRow,
    Paperclip,
    PersonAdd,
    PersonRemove,
    PhoneBook,
    Customer,
    GetMoney,
    Pointer,
    PointerAlt,
    PriceTag,
    Format,
    Stop,
    More,
    Speed,
    Expand,
    Shrink,
    Visible,
    Xandr,
    Placeholder,
    ProjectStatus,
    Screenshot,
    Laptop,
    Code,
    Collapse,
    ReportLevelFirst,
    ReportLevelSecond,
    ReportLevelThird,
    ReportLevelThirdReverse,
};
export default Icons;
